import { render, staticRenderFns } from "./ArriveAddressBafCostList.vue?vue&type=template&id=427d9797&scoped=true"
import script from "./ArriveAddressBafCostList.vue?vue&type=script&lang=js"
export * from "./ArriveAddressBafCostList.vue?vue&type=script&lang=js"
import style0 from "./ArriveAddressBafCostList.vue?vue&type=style&index=0&id=427d9797&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427d9797",
  null
  
)

export default component.exports